import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Chart, registerables } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ChartDataLabels from "chartjs-plugin-datalabels";
import zoomPlugin from 'chartjs-plugin-zoom';
import circle from './circle.png';
import { API_BASE_URL } from './config';
import "./style.css";
import "./FrequencyResponseFunction.css";
Chart.register(ChartDataLabels);
Chart.register(...registerables, zoomPlugin);

const CastingGrade = () => {
  const navigate = useNavigate();

  const onCastingManagement = (e) => {
    e.preventDefault();
    navigate('/casting-management');
  };

  const onVFRF = (e) => {
    e.preventDefault();
    navigate('/casting-view-frequency-response-function');
  };

  const { axis } = useParams();
  const [activeTab, setActiveTab] = useState(axis || "X");

  useEffect(() => {
    setActiveTab(axis || "X");
  }, [axis]);

  const [machineList, setMachineList] = useState([]);
  const [userDepartment, setUserDepartment] = useState(""); // 新增：狀態來儲存使用者部門
  
  useEffect(() => {
    // 從 localStorage 取得部門資訊
    const dept = localStorage.getItem("department"); 
    setUserDepartment(dept || ""); // 如果沒有找到，預設為空字串
  }, []);

  const fetchMachineData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getdata/castingData`);
      console.log('CastingManagement', response.data);
      setMachineList(response.data);
    } catch (error) {
      console.error('獲取機台資料失敗:', error);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {
    fetchMachineData();
    setShowModal(true);
  };

  const [selectedMachines, setSelectedMachines] = useState([]);

  const handleCheckboxChange = (index) => {
    setSelectedMachines((prevSelected) =>
      prevSelected.includes(index) ? prevSelected.filter((id) => id !== index) : [...prevSelected, index]);
  };

  const [coverData, setcoverData] = useState([]);
  const [lineLabels, setlineLabels] = useState([]);

  const [ok1, setOk1] = useState(0);
  const [other1, setOther1] = useState(0);
  const [ok2, setOk2] = useState(0);
  const [other2, setOther2] = useState(0);
  const [ok3, setOk3] = useState(0);
  const [other3, setOther3] = useState(0);
  const [ok4, setOk4] = useState(0);
  const [other4, setOther4] = useState(0);

  const [ok1Client, setOk1Client] = useState([]);
  const [other1Client, setOther1Client] = useState([]);
  const [ok2Client, setOk2Client] = useState([]);
  const [other2Client, setOther2Client] = useState([]);
  const [ok3Client, setOk3Client] = useState([]);
  const [other3Client, setOther3Client] = useState([]);
  const [ok4Client, setOk4Client] = useState([]);
  const [other4Client, setOther4Client] = useState([]);

  const handleConfirmSelection = () => {
    const newChartData = selectedMachines.map((machineId) => {
      const machine = machineList.find((m) => m._id === machineId);
      if (!machine) return null;

      const freq = Array.isArray(machine.updata.Amp_peak_data) ? machine.updata.Amp_peak_data : [machine.updata.Amp_peak_data];
      const amplitude = Array.isArray(machine.updata.Amp_peak_freq_data) ? machine.updata.Amp_peak_freq_data : [machine.updata.Amp_peak_freq_data];

      const extractedFreq = freq.flat();
      const extractedAmplitude = amplitude.flat();

      return {
        client: machine.client,
        label: machine.updata.chartData.ch_name,
        amp_peak_data: extractedFreq,
        amp_peak_freq_data: extractedAmplitude,
        data: (Array.isArray(machine.updata.chartData.magn)
          ? machine.updata.chartData.magn
          : [machine.updata.chartData.magn]).slice(9),
        labels: machine.updata.chartData.freq.slice(9),
        fill: true,
        tension: 0.4,
        labels: machine.updata.chartData.freq,
        isOther1: false
      };
    }).filter(item => item !== null);

    setcoverData(newChartData);
    setlineLabels(newChartData[0]?.labels.slice(9) || []);
    setShowModal(false);

    let ok1 = 0;
    let other1 = 0;
    let ok2 = 0;
    let other2 = 0;
    let ok3 = 0;
    let other3 = 0;
    let ok4 = 0;
    let other4 = 0;

    let ok1Client = [];
    let other1Client = [];
    let ok2Client = [];
    let other2Client = [];
    let ok3Client = [];
    let other3Client = [];
    let ok4Client = [];
    let other4Client = [];

    if (newChartData.length > 0) {
      const firstSelectedMachine = machineList.find((m) => m._id === selectedMachines[0]);
      const baselineMachine = machineList.find((m) =>
        m.company === firstSelectedMachine.company && m.machineModel === firstSelectedMachine.machineModel
      );

      const firstFreqData = baselineMachine.updata.Amp_peak_freq_data;
      const firstAmpPeakData = baselineMachine.updata.Amp_peak_data;

      newChartData.forEach((item) => {
        let isOtherA1 = false;
        let isOtherA2 = false;
        let isOtherA3 = false;
        let isOtherA4 = false;

        if (item.amp_peak_data && item.amp_peak_freq_data) {
          const ampResults = [];
          let sum = 0;
          item.amp_peak_data.forEach((ampValue, i) => {
            const freqValue = item.amp_peak_freq_data[i];
            // 找出基準頻率中 ±1Hz 內的第一筆
            const matchIndex = firstFreqData.findIndex(baseFreq => {
              return Math.abs(freqValue - baseFreq) <= 1;
            });
            if (matchIndex !== -1) {
              const baseAmp = firstAmpPeakData[matchIndex];
              const result = ((ampValue - baseAmp) / baseAmp) * 100;
              if (!isNaN(result)) {
                ampResults.push(result);
                sum += result;
              }
            }
          });

          const average = ampResults.length > 0 ? sum / ampResults.length : 0;

          isOtherA1 = !(average >= -10 && average <= -6);
          isOtherA2 = !(average > -6 && average <= 0);
          isOtherA3 = !(average > 0 && average <= 5);
          isOtherA4 = !(average > 5 && average <= 10);
          console.log(`
                幅差: ${ampResults}
                總和: ${sum}
                差異%: ${average}
                isOtherA1: ${isOtherA1}
                isOtherA2: ${isOtherA2}
                isOtherA3: ${isOtherA3}
                isOtherA4: ${isOtherA4}
              `);
        }

        if (!isOtherA1) {
          ok1++;
          ok1Client.push(item.client);
        } else {
          other1++;
          other1Client.push(item.client);
        }

        if (!isOtherA2) {
          ok2++;
          ok2Client.push(item.client);
        } else {
          other2++;
          other2Client.push(item.client);
        }

        if (!isOtherA3) {
          ok3++;
          ok3Client.push(item.client);
        } else {
          other3++;
          other3Client.push(item.client);
        }

        if (!isOtherA4) {
          ok4++;
          ok4Client.push(item.client);
        } else {
          other4++;
          other4Client.push(item.client);
        }

        /*console.log('GO1 料號', ok1Client);
        console.log('other1 料號', other1Client);
        console.log('GO2 料號', ok2Client);
        console.log('other2 料號', other2Client);
        console.log('GO3 料號', ok3Client);
        console.log('other3 料號', other3Client);
        console.log('GO4 料號', ok4Client);
        console.log('other4 料號', other4Client);*/

        item.isOtherA1 = isOtherA1;
        item.isOtherA2 = isOtherA2;
        item.isOtherA3 = isOtherA3;
        item.isOtherA4 = isOtherA4;
      });
    }

    setOk1(ok1);
    setOther1(other1);
    setOk2(ok2);
    setOther2(other2);
    setOk3(ok3);
    setOther3(other3);
    setOk4(ok4);
    setOther4(other4);
    setOk1Client(ok1Client);
    setOther1Client(other1Client);
    setOk2Client(ok2Client);
    setOther2Client(other2Client);
    setOk3Client(ok3Client);
    setOther3Client(other3Client);
    setOk4Client(ok4Client);
    setOther4Client(other4Client);
  };

  const lineChartRef = useRef(null);

  const createLineChart = (chartRef, datasets) => {
    const chartInstance = new Chart(lineChartRef.current, {
      type: "line",
      data: { labels: chartRef, datasets: datasets },
      options: {
        layout: {
          padding: { right: -80 } // 圖例位置調整
        },
        scales: {
          y: {
            ticks: { beginAtZero: true },
            title: { display: true, text: 'Amplitude (μm/N)', font: { size: 14 }, padding: 15 }
          },
          x: {
            type: 'linear',
            min: 100, max: 1000,
            title: { display: true, text: 'Frequency (Hz)', font: { size: 14 }, padding: 15 },
            ticks: {
              beginAtZero: true,
              stepSize: 25,
              callback: function (value) {
                return Math.round(value);
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        fill: true,
        elements: {
          point: { radius: 0, hitRadius: 10 },
          line: { tension: 0.4 }
        },
        plugins: {
          legend: {
            position: 'bottom',
            display: true,
            labels: {
              usePointStyle: true,
              pointStyle: 'rect',
              font: { size: 13 } // 折線圖圖例尺寸
            },
            onClick: (e, legendItem, legend) => {
              const datasetIndex = legendItem.datasetIndex;
              const chart = legend.chart;
              const dataset = chart.data.datasets[datasetIndex];

              const meta = chart.getDatasetMeta(datasetIndex);
              meta.hidden = !meta.hidden;
              const isHidden = meta.hidden;

              const firstSelectedMachine = machineList.find((m) => m._id === selectedMachines[0]);
              const baselineMachine = machineList.find((m) =>
                m.company === firstSelectedMachine.company && m.machineModel === firstSelectedMachine.machineModel
              );

              const firstFreqData = baselineMachine.updata.Amp_peak_freq_data;
              const firstAmpPeakData = baselineMachine.updata.Amp_peak_data;

              let isOtherA1 = false;
              let isOtherA2 = false;
              let isOtherA3 = false;
              let isOtherA4 = false;

              if (dataset.amp_peak_data) {
                const ampResults = [];
                let sum = 0;
                dataset.amp_peak_data.forEach((value, i) => {
                  const result = ((value - firstAmpPeakData[i]) / firstAmpPeakData[i]) * 100;
                  if (!isNaN(result)) {
                    ampResults.push(result);
                    sum += result;
                  }
                });
                const average = sum / ampResults.length;

                isOtherA1 = !(average >= -10 && average <= -6);
                isOtherA2 = !(average >= -5 && average <= 0);
                isOtherA3 = !(average >= 1 && average <= 5);
                isOtherA4 = !(average >= 6 && average <= 10);
              }

              const client = chart.data.datasets[datasetIndex].client;

              if (isHidden) {
                if (!isOtherA1) {
                  setOk1((prev) => prev - 1);
                  setOk1Client((prev) => {
                    if (!Array.isArray(prev)) return prev; // 確保 prev 是陣列
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                } else {
                  setOther1((prev) => prev - 1);
                  setOther1Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                }

                if (!isOtherA2) {
                  setOk2((prev) => prev - 1);
                  setOk2Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                } else {
                  setOther2((prev) => prev - 1);
                  setOther2Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                }

                if (!isOtherA3) {
                  setOk3((prev) => prev - 1);
                  setOk3Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                } else {
                  setOther3((prev) => prev - 1);
                  setOther3Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                }

                if (!isOtherA4) {
                  setOk4((prev) => prev - 1);
                  setOk4Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                } else {
                  setOther4((prev) => prev - 1);
                  setOther4Client((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(client);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1);
                      return newMachines;
                    }
                    return prev;
                  });
                }
              } else {
                if (!isOtherA1) {
                  setOk1((prev) => prev + 1);
                  setOk1Client((prev) => [...prev, client]);
                } else {
                  setOther1((prev) => prev + 1);
                  setOther1Client((prev) => [...prev, client]);
                }

                if (!isOtherA2) {
                  setOk2((prev) => prev + 1);
                  setOk2Client((prev) => [...prev, client]);
                } else {
                  setOther2((prev) => prev + 1);
                  setOther2Client((prev) => [...prev, client]);
                }

                if (!isOtherA3) {
                  setOk3((prev) => prev + 1);
                  setOk3Client((prev) => [...prev, client]);
                } else {
                  setOther3((prev) => prev + 1);
                  setOther3Client((prev) => [...prev, client]);
                }

                if (!isOtherA4) {
                  setOk4((prev) => prev + 1);
                  setOk4Client((prev) => [...prev, client]);
                } else {
                  setOther4((prev) => prev + 1);
                  setOther4Client((prev) => [...prev, client]);
                }
              }
              chart.update();
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (context) {
                const label = context.dataset.label || '';
                const xValue = context.label;
                const yValue = context.raw.toFixed(4);
                return `${label}   ( ${xValue} , ${yValue} )`;
              },
              title: function () {
                return '';
              }
            }
          },
          datalabels: { display: false },
          zoom: {
            pan: {
              enabled: false,
            },
            zoom: {
              wheel: { enabled: false },
              pinch: { enabled: false },
              mode: 'x',
              drag: {
                enabled: true,
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                threshold: 2,
                delay: 50
              }
            },
            onZoom: ({ chart }) => {
              let xScale = chart.scales.x;
              let min = Math.max(xScale.min, 100);
              let max = Math.min(xScale.max, 1000);

              chart.options.scales.x.min = min;
              chart.options.scales.x.max = max;
              chart.options.scales.x.ticks.stepSize = 25;
              chart.update();
            }
          }
        }
      }
    });
    lineChartRef.current.chartInstance = chartInstance;
    return chartInstance;
  };

  const resetZoom = () => {
    if (lineChartRef.current && lineChartRef.current.chartInstance) {
      lineChartRef.current.chartInstance.resetZoom();
    }
  };

  useEffect(() => {
    let lineChart;
    if (lineChartRef.current) lineChart?.destroy();
    lineChart = createLineChart(lineLabels, coverData);
    return () => {
      lineChart?.destroy();
    };
  }, [coverData]);

  useEffect(() => {
    if (selectedMachines.length > 0) {
      handleConfirmSelection();
    }
  }, [activeTab]);

  const colors = {
    color1: "rgb(240, 173, 167)",
    color2: "rgb(254, 214, 144)",
    color3: "rgb(124, 166, 217)",
    color4: "rgb(180, 218, 134)"
  };

  const generateChartData = (ok, other, label, color, okClient, otherClient) => ({
    data: {
      labels: [label, "other"],
      datasets: [{
        data: [ok, other],
        backgroundColor: [color, "rgb(202, 213, 224)"],
        okClient: okClient,
        otherClient: otherClient
      }]
    },
    options: {
      maintainAspectRatio: false,
      cutout: 15, // 圓餅圖 胖度
      plugins: {
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            usePointStyle: true,
            pointStyle: 'rect',
            padding: 40, // 圓餅圖 圖例位置
            font: {
              size: 13 // 圓餅圖 圖例大小
            }
          },
          onClick: () => { }
        },
        datalabels: {
          display: true,
          color: '#ffffff',
          font: { size: 15 }, // 圓餅圖 %數值尺寸
          formatter: (value, context) => {
            const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
            const percentage = ((value / total) * 100).toFixed(0);
            return `${percentage}%`;
          }
        },
        tooltip: {
          enabled: false, // 禁用內建 tooltip，使用自訂 tooltip
          external: function (context) {
            let tooltipEl = document.getElementById("chart-tooltip");

            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chart-tooltip";
              tooltipEl.style.position = "absolute";
              tooltipEl.style.background = "rgba(0, 0, 0, 0.8)";
              tooltipEl.style.color = "white";
              tooltipEl.style.padding = "8px";
              tooltipEl.style.borderRadius = "5px";
              tooltipEl.style.fontSize = "13px";
              tooltipEl.style.pointerEvents = "none";
              tooltipEl.style.transition = "opacity 0.2s";
              tooltipEl.style.zIndex = "3"; // 確保 tooltip 顯示在最上層
              document.body.appendChild(tooltipEl);
            }

            const tooltipModel = context.tooltip;
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = "0";
              return;
            }

            const dataPoint = tooltipModel.dataPoints[0];
            const dataset = dataPoint.dataset;

            let tooltipText = "";
            if (dataPoint.label === label) {
              tooltipText = ` ${dataset.okClient}`;
            } else if (dataPoint.label === "other") {
              tooltipText = ` ${dataset.otherClient}`;
            }

            tooltipEl.innerHTML = tooltipText; //套用給tooltip的內容，上一段為內容的宣告
            tooltipEl.style.opacity = "1"; //tooltip透明度，範圍0-1

            // 正確計算 tooltip 位置，在滑鼠附近顯示
            document.addEventListener("mousemove", (event) => {
              tooltipEl.style.left = `${event.clientX + 15}px`;
              tooltipEl.style.top = `${event.clientY + 5}px`;
            });
          }
        }
      }
    }
  });

  const data1 = generateChartData(ok1, other1, "-10% ~ -6%", colors.color1, ok1Client, other1Client);
  const data2 = generateChartData(ok2, other2, "-5% ~ 0%", colors.color2, ok2Client, other2Client);
  const data3 = generateChartData(ok3, other3, "1% ~ 5%", colors.color3, ok3Client, other3Client);
  const data4 = generateChartData(ok4, other4, "6% ~ 10%", colors.color4, ok4Client, other4Client);

  //圖示資料 全選功能
  const [isAllSelected, setIsAllSelected] = useState(false);
  const handleToggleSelectAll = () => {
    if (selectedMachines.length === 0) return;

    const baseMachine = machineList.find(m => m._id === selectedMachines[0]);
    if (!baseMachine) return;

    const { company, machineModel } = baseMachine;

    if (!isAllSelected) {
      const sameGroupMachines = machineList
        .filter(machine =>
          machine.company === company &&
          machine.machineModel === machineModel
        )
        .map(machine => machine._id);

      setSelectedMachines(sameGroupMachines);
      setIsAllSelected(true);
    } else {
      setSelectedMachines([]);
      setIsAllSelected(false);
    }
  };

  return (
    <div>
      <div className="d-flex" style={{ width: '81.7%', margin: '0 auto' }}>
        <div className="container-fluid">
          <div style={{ height: '35px', width: '100%' }}></div>

          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#" onClick={onCastingManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>鑄件資料庫</a>
              </li>
              <li className="breadcrumb-item">
                <a href="#" onClick={onVFRF} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>頻率響應函數</a>
              </li>
              <li
                className="breadcrumb-item"
                aria-current="page"
                style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>等級分析
              </li>
            </ol>
          </nav>

          <div className="d-flex justify-content-end" style={{ paddingRight: '20px' }}>
            <button
              className="reset-btn bi bi-arrow-clockwise"
              onClick={resetZoom}
            >
            </button>

            <button
              className="btn2"
              style={{ height: '35px', width: '75px' }}
              onClick={() => { setShowModal(true); handleShowModal(); }}
            >
              圖示資料
            </button>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "50px", flexWrap: "wrap", gap: "20px" }}>
            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut
                data={data1.data}
                options={data1.options}
                style={{ zIndex: 2, pointerEvents: "auto" }} // 確保圓餅圖可以接收事件
              />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none" // 讓圖片不影響滑鼠事件
                }}
              />
            </div>

            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut data={data2.data} options={data2.options} />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }}
              />
            </div>

            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut data={data3.data} options={data3.options} />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }}
              />
            </div>

            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut data={data4.data} options={data4.options} />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }}
              />
            </div>
          </div>

          <div style={{ height: '45px', width: '100%' }}></div>

          <Modal show={showModal} onHide={() => setShowModal(false)} scrollable>
            <Modal.Header closeButton>
              <Modal.Title>圖示資料選擇</Modal.Title>
              {selectedMachines.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className={`select-model-button ${isAllSelected ? 'cancel' : 'select'}`}
                    onClick={handleToggleSelectAll}
                    style={{
                      padding: '2px 10px',
                      height: '28px',
                      lineHeight: '1.2',
                      marginLeft: '12px',
                      marginTop: '15px'
                    }}
                  >
                    {isAllSelected
                      ? '取消全選'
                      : `全選：${machineList.find(m => m._id === selectedMachines[0])?.machineModel.split('-')[0]}`}
                  </Button>
                </div>
              )}
            </Modal.Header>
            <Modal.Body>
              {machineList
                .filter((machine) => {
                  return machine.department === userDepartment;
                })
                .map((machine) => {
                  const isDisabled = selectedMachines.length > 0 && (
                    machineList.find((m) => m._id === selectedMachines[0]).company !== machine.company ||
                    machineList.find((m) => m._id === selectedMachines[0]).machineModel !== machine.machineModel
                  );
                  return (
                    <div
                      key={machine._id}
                      style={{ marginBottom: '10px' }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={machine._id}
                        id={`modal-machine-${machine._id}`}
                        checked={selectedMachines.includes(machine._id)}
                        onChange={() => handleCheckboxChange(machine._id)}
                        disabled={isDisabled}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`modal-machine-${machine._id}`}
                        style={{ marginLeft: '10px', color: isDisabled ? '#A9A9A9' : '#636363' }}
                      >
                        {machine.updata.chartData.filename}
                      </label>
                    </div>

                  );
                })
              }
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center gap-4">
              <Button
                className="btn-cancel"
                style={{ height: '35px', width: '75px' }}
                onClick={() => setShowModal(false)}
              >
                取消
              </Button>
              <Button
                variant="btn-confirm btn-primary"
                style={{ height: '35px', width: '75px' }}
                onClick={handleConfirmSelection}
              >
                確認
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div >

      <div className="d-flex" style={{ width: '81.7%', height: "480px", margin: '0 auto' }}>
        <canvas ref={lineChartRef}></canvas>
      </div>
      <div style={{ height: '35px', width: '100%' }}></div>
    </div >
  );
};

export default CastingGrade;